import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  shopifySignup: JSON.parse(localStorage.getItem("shopify_signup")),
  needShopifydownload: JSON.parse(
    localStorage.getItem("need_download_shopify_products")
  ),
  shopifyWsLimitAvail: JSON.parse(
    localStorage.getItem("spf_ws_limit_available")
  ),
};

const setShopifySignup = (state, action) => {
  state.shopifySignup = action.payload;
};
const setNeedShopifyDownload = (state, action) => {
  state.needShopifydownload = action.payload;
};
const setShopifyWsLimitAvail = (state, action) => {
  state.shopifyWsLimitAvail = action.payload;
};

const shopifyStateSlice = createSlice({
  name: "shopifyStates",
  initialState,
  reducers: {
    setShopifySignup,
    setNeedShopifyDownload,
    setShopifyWsLimitAvail,
  },
});

export default shopifyStateSlice.reducer;
